module.exports = __webpack_public_path__ + "static/img/value-icon1-blue.b8413166.png";